import { ToggleButton, ToggleButtonProps } from "@mui/material";
import { ReactElement } from "react";

type TCourseTabsToggleButtonProps = Omit<ToggleButtonProps, "size">;

export const CourseTabsToggleButton = ({
  ...props
}: TCourseTabsToggleButtonProps): ReactElement => {
  return (
    <ToggleButton {...props} size="small" sx={{ width: 100, height: 32 }} />
  );
};
